<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}</h3>
                </header>
            </section>
            <div class="divisor8"></div>
            <section class="widget">
                <div class="row">
                    <div class="col-8">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Persona a evaluar'" [(ngModel)]="entidad.nombre" [disabled]="true"  [errorActivo]="errorActivo" ></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Puesto'" [disabled]="true" [(ngModel)]="entidad.puesto"  [errorActivo]="errorActivo" ></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Departamento'" [(ngModel)]="entidad.departamento" [disabled]="true"  [errorActivo]="errorActivo" ></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                              <inputCustom [titulo]="'Nivel'" [(ngModel)]="entidad.nombrenivel" [disabled]="true"  [errorActivo]="errorActivo" ></inputCustom>
                          </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Evaluadores'" [(ngModel)]="accion.accion" [disabled]="true"  [errorActivo]="errorActivo" ></inputCustom>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-12 col-12">
                              <button matTooltip="Exportar a exel" class="boton botonSM filledBlanco"
                                  (click)="Exportar()">
                                   <span> {{'Exportar a exel'}}</span>
                              </button>
                          </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div *ngIf="entidad.urlfotografia">
                                    <div class="imagencolaborador">
                                        <imagenVisualizador [imagen]="entidad.urlfotografia"  [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleToFill"></imagenVisualizador>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12"*ngIf="accion.accionid != 5 && accion.accionid != 6">
                      <div class="row">
                        <div class="col-3" *ngIf="accion.accionid == 1">
                          <dropdownCustom titulo="Seleccionar las preguntas a visualizar para:"
                          [opciones]="listacolaboradorrelacion"
                          [(ngModel)]="colaboradorrelacionid"
                          [valorName]="'colaboradorrelacionid'"
                          [displayValor]="'nombre'"
                          [buscar]="false"
                          (ngModelChange)="verpreguntas($event)"
                          ></dropdownCustom>
                        </div>
                        <div class="col-3" *ngIf="accion.accionid != 1">
                          <dropdownCustom titulo="Seleccionar las preguntas a visualizar para:"
                          [opciones]="listatipoplantilla"
                          [(ngModel)]="tipoplantillaid"
                          [valorName]="'tipoplantillaid'"
                          [displayValor]="'nombre'"
                          [buscar]="false"
                          (ngModelChange)="verpreguntasalumnos($event)"
                          ></dropdownCustom>
                        </div>
                      </div>
                    </div>
                </div>

                <mat-tab-group #tab preserveContent mat-stretch-tabs>
                    <mat-tab label="Preguntas">
                        <reporteevaluacionpendientepreguntaenviadadetalle_pregunta #general *ngIf="listapreguntas.length > 0"
                            [entidad]= "entidad"
                            [accion]="accion"
                            [listapreguntas]="listapreguntas"
                            (output)="formulario()"
                            (salir)="Salir()">
                        </reporteevaluacionpendientepreguntaenviadadetalle_pregunta>
                    </mat-tab>
                    <mat-tab label="Personas que evalúan">
                        <reporteevaluacionpendientepreguntaenviadadetalle_personaevalua *ngIf="listaevaluador.length > 0"
                            [entidad]= "entidad"
                            [accion]="accion"
                            [listaevaluador]="listaevaluador"
                        >
                        </reporteevaluacionpendientepreguntaenviadadetalle_personaevalua>
                    </mat-tab>
                </mat-tab-group>

                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                            (click)="Salir()">
                            <span> {{'Cerrar'}}</span>
                        </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div #asignacionevaluacionalumnosmaterias></div>
